// src/services/pacs.js - PACS infrastructure (Orthanc + scan-board data)
import api from './api';

export const getScanBoardStudies = async (params = {}) => {
  try {
    const response = await api.get('/studies/patients/studies', { params });
    return response.data;
  } catch (error) {
    console.error('Get scan-board studies error:', error);
    throw error;
  }
};

export const getPatients = async (params = {}) => {
  try {
    const response = await api.get('/studies/patients', { params });
    return response.data;
  } catch (error) {
    console.error('Get patients error:', error);
    throw error;
  }
};

export const syncOrthanc = async () => {
  try {
    const response = await api.post('/studies/sync-orthanc');
    return response.data;
  } catch (error) {
    console.error('Sync Orthanc error:', error);
    throw error;
  }
};

export const pingOrthanc = async () => {
  const response = await api.get('/studies/orthanc-ping');
  return response.data;
};

export const assignStudyToRadiologist = async (studyId, radiologistId, radiologistName, reason) => {
  try {
    const response = await api.patch(`/studies/${studyId}/assign-radiologist`, {
      radiologistId, radiologistName, reason,
    });
    return response.data;
  } catch (error) {
    console.error('Assign study error:', error);
    throw error;
  }
};

export const getStudyAssignmentHistory = async (studyId) => {
  try {
    const response = await api.get(`/studies/${studyId}/assignment-history`);
    return response.data;
  } catch (error) {
    console.error('Get study assignment history error:', error);
    throw error;
  }
};
